import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=6c676c74&scoped=true&lang=pug&"
import script from "./ContractList.vue?vue&type=script&lang=js&"
export * from "./ContractList.vue?vue&type=script&lang=js&"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=6c676c74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c676c74",
  null
  
)

export default component.exports